module.exports = __webpack_public_path__ + "static/media/options-1.21a0be6e.svg";